// Constantes centralizadas para priorização de itens
// Usadas em: useShoppingList, ShoppingListDrawer, ShoppingList

export const PRIORITY_LEVELS = {
  high: 2,
  medium: 1,
  low: 0,
} as const;

export type PriorityLevel = keyof typeof PRIORITY_LEVELS;
export type PriorityValue = typeof PRIORITY_LEVELS[PriorityLevel];

export const PRIORITY_CONFIG: Record<PriorityLevel, {
  label: string;
  color: string;
  bgColor: string;
  icon: string;
}> = {
  high: {
    label: "Alta",
    color: "text-destructive",
    bgColor: "bg-destructive/10",
    icon: "AlertCircle",
  },
  medium: {
    label: "Média",
    color: "text-warning",
    bgColor: "bg-warning/10",
    icon: "CircleDot",
  },
  low: {
    label: "Baixa",
    color: "text-muted-foreground",
    bgColor: "bg-muted",
    icon: "Circle",
  },
};

export function getPriorityFromValue(value: number | null | undefined): PriorityLevel {
  if (value === null || value === undefined) return "low";
  if (value >= PRIORITY_LEVELS.high) return "high";
  if (value >= PRIORITY_LEVELS.medium) return "medium";
  return "low";
}

export function getPriorityConfig(value: number | null | undefined) {
  return PRIORITY_CONFIG[getPriorityFromValue(value)];
}
